import {createBorder} from '../../common';

declare let THREE: any;

export class EmptyRect extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));

  public static readonly Name = 'EmptyRect';

  constructor(size: number) {
    const geometry = new THREE.PlaneBufferGeometry(size, size).applyMatrix(EmptyRect.rotationTransform);
    const mat = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
      color: 0xffffff
    });
    super(geometry, mat);
    const border = createBorder(geometry.clone());
    this.add(border);
    this.name = EmptyRect.Name;
  }



}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/EmptyRect.ts